export default __webpack_public_path__ + "static/media/icon.scissors.2e4fe1f8.svg";